import React from "react";
import { Card, Elevation, Divider } from '@blueprintjs/core';

const SiteFooter = () => {
    return (
        <React.Fragment>
            <div style={{ padding: '8px' }}>
                <Card elevation={Elevation.TWO}>
                    {/* Footer */}
                    <div style={{ borderTop: '1px solid #d3d3d3', marginTop: '20px', paddingTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                        <Divider />
                        {/*<div style={{display: 'flex', alignItems: 'center'}}>*/}
                        {/*    <span>PRIVATE TOOL USED BY HCCB PVT LTD</span>*/}
                        {/*    <img src="/HCCB.png" alt="Coca-Cola Logo" width="100" />*/}
                        {/*</div>*/}
                    </div>
                </Card>
            </div>
        </React.Fragment>
    );
}
export default SiteFooter;